module.exports = __webpack_public_path__ + "static/media/S2N13-1.237571bd.svg";